import PreLoader from "../../components/PreLoader";

function TestPreLoader() {
  return (
    <>
        <PreLoader />
    </>
  );
}

export default TestPreLoader;
